import { Toaster as SonnerToaster } from "sonner";

import { useTheme } from "@/hooks/useTheme";

/** App-wide toast host. Mirrors the active theme. */
export function Toaster(): JSX.Element {
  const { resolvedTheme } = useTheme();
  return (
    <SonnerToaster
      theme={resolvedTheme}
      richColors
      closeButton
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: "group rounded-md border bg-background text-foreground shadow-lg",
        },
      }}
    />
  );
}
